import React from 'react';
import { cn } from '../../lib/cn';
import { Icon } from '../Icon/Icon';
import type { IconKind } from '../Icon/Icon';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconKind;
  active?: boolean;
  size?: number;
  label?: string;
}

export function IconButton({ icon, active, size = 36, label, className, ...props }: IconButtonProps) {
  return (
    <button
      {...props}
      aria-label={props['aria-label'] ?? label}
      className={cn(
        'inline-flex cursor-pointer items-center justify-center rounded-full border border-[var(--cream-2)] transition hover:bg-[var(--cream-0)] disabled:cursor-not-allowed',
        active ? 'bg-[var(--sage-0)] text-white' : 'bg-[var(--cream-1)] text-[var(--ink-2)]',
        className
      )}
      style={{ width: size, height: size }}
    >
      <Icon kind={icon} size={size * 0.44} stroke={1.8} />
    </button>
  );
}
